<template>
  <BreadCrumb PageTitle="Bons Suivi livreur" />
  <AddNote />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import AddNote from "@/components/Notes/Pointage/AddNote.vue";

export default defineComponent({
  name: "AddNotePage",
  components: {
    BreadCrumb,
    AddNote,
  },
});
</script>